module.exports = __webpack_public_path__ + "img/icon_map_bs.e07b5838.png";